"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = getErrorMessage;
exports.isNetworkError = isNetworkError;
exports.isAuthError = isAuthError;
exports.isValidationError = isValidationError;
exports.getValidationErrors = getValidationErrors;
/**
 * Extract error message from RTK Query error
 */
function getErrorMessage(error, defaultMessage) {
    if (defaultMessage === void 0) { defaultMessage = "An unexpected error occurred"; }
    // Handle RTK Query FetchBaseQueryError
    if (error && typeof error === "object" && "status" in error) {
        var fetchError = error;
        // Check if error has data with message
        if (fetchError.data && typeof fetchError.data === "object") {
            var errorData = fetchError.data;
            // Check for nested error structure: { content: { message: "...", errors: [{ key, message }] } }
            if (errorData.content && typeof errorData.content === "object") {
                var content = errorData.content;
                // First check for errors array with validation messages
                if (Array.isArray(content.errors) && content.errors.length > 0) {
                    // Return all error messages joined
                    return content.errors.map(function (e) { return e.message; }).join(". ");
                }
                // Fallback to content.message (e.g., "Validation failed")
                if (content.message) {
                    return content.message;
                }
            }
            // Fallback to top-level message
            if (errorData.message) {
                return errorData.message;
            }
            // Check for standard error format
            if ("error" in errorData && typeof errorData.error === "string") {
                return errorData.error;
            }
        }
        // Handle HTTP status codes - only use generic messages as last resort
        if (fetchError.status === "FETCH_ERROR") {
            return "Network error. Please check your connection and try again.";
        }
        if (fetchError.status === "PARSING_ERROR") {
            return "Failed to parse server response.";
        }
        // For numeric status codes, only return generic message if no API message was found
        if (typeof fetchError.status === "number") {
            // These are truly exceptional cases where we have no message
            switch (fetchError.status) {
                case 502:
                case 503:
                case 504:
                    return "Service temporarily unavailable. Please try again later.";
                default:
                    // Return a generic message based on status if nothing else was extracted
                    return defaultMessage;
            }
        }
    }
    // Handle SerializedError
    if (error && typeof error === "object" && "message" in error) {
        var serializedError = error;
        if (serializedError.message) {
            return serializedError.message;
        }
    }
    // Handle Error objects
    if (error instanceof Error) {
        return error.message;
    }
    // Handle string errors
    if (typeof error === "string") {
        return error;
    }
    return defaultMessage;
}
/**
 * Check if error is a network error
 */
function isNetworkError(error) {
    if (error && typeof error === "object" && "status" in error) {
        var fetchError = error;
        return fetchError.status === "FETCH_ERROR";
    }
    return false;
}
/**
 * Check if error is an authentication error
 */
function isAuthError(error) {
    if (error && typeof error === "object" && "status" in error) {
        var fetchError = error;
        return fetchError.status === 401;
    }
    return false;
}
/**
 * Check if error is a validation error
 */
function isValidationError(error) {
    if (error && typeof error === "object" && "status" in error) {
        var fetchError = error;
        return fetchError.status === 422 || fetchError.status === 400;
    }
    return false;
}
/**
 * Extract validation errors from error response
 */
function getValidationErrors(error) {
    if (error && typeof error === "object" && "data" in error) {
        var fetchError = error;
        if (fetchError.data && typeof fetchError.data === "object") {
            var errorData = fetchError.data;
            if (errorData.errors && typeof errorData.errors === "object") {
                return errorData.errors;
            }
        }
    }
    return null;
}
